import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
// import MenuIcon from "@mui/icons-material/Menu";
import { Text } from "@/components/text/Text";
import { useLanguageContext } from "@/context/LanguageContext";
import { useStyle } from "@/context/StyleContext";
import {
  Inbox,
  KeyboardArrowDown,
  LinkedIn,
  Mail,
  MenuOpen,
  Menu as MenuIcon,
  Chair as ChairIcon,
  Info as InfoIcon,
  AutoFixHigh as AutoFixHighIcon,
  BookOnline as BookOnlineIcon,
} from "@mui/icons-material";
import {
  SwipeableDrawer,
  Drawer,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ReactCountryFlag from "react-country-flag";
// import NoTextLogo from "../logos/NoTextLogo";

import Logo from "@/components/logos/Logo";
import { SvgGResizer } from "react-svg-resizer";

export default function DefaultAppBar() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = React.useState(false);
  const stylesProvider = useStyle();

  const { lang } = useLanguageContext();

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const menuItems: {
    text: string;
    sectionId?: string;
    isLogo?: boolean;
    icon: React.ReactNode;
  }[] = [
    {
      text: lang.t("landing.appBar.services"),
      sectionId: "section-services",
      icon: (
        <ChairIcon
          sx={{ color: stylesProvider.colors[stylesProvider.theme].highlight }}
        />
      ),
    },
    {
      text: lang.t("landing.appBar.ourStyle"),
      sectionId: "section-our-style",
      icon: (
        <AutoFixHighIcon
          sx={{ color: stylesProvider.colors[stylesProvider.theme].highlight }}
        />
      ),
    },
    {
      text: lang.t("landing.appBar.aboutUs"),
      sectionId: "section-about-us",
      icon: (
        <InfoIcon
          sx={{ color: stylesProvider.colors[stylesProvider.theme].highlight }}
        />
      ),
    },
    {
      text: "High Hair Room",
      sectionId: "logo",
      isLogo: true,
      icon: (
        <Logo
          onClick={() => {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          }}
          size={60}
          containerStyle={{
            marginBottom: "10px",
            background: stylesProvider.colors[stylesProvider.theme].text,
            padding: "10px 16px",
            borderRadius: "20%",
          }}
        />
      ),
    },

    {
      text: lang.t("landing.appBar.booking"),
      sectionId: "section-book-now",
      icon: (
        <BookOnlineIcon
          sx={{ color: stylesProvider.colors[stylesProvider.theme].highlight }}
        />
      ),
    },
    {
      text: lang.t("landing.appBar.contactUs"),
      sectionId: "section-footer",
      icon: (
        <Mail
          sx={{ color: stylesProvider.colors[stylesProvider.theme].highlight }}
        />
      ),
    },
  ];

  const DrawerList = (
    <Box
      sx={{ width: 250, paddingTop: 2 }}
      role="presentation"
      onClick={toggleDrawer(false)}
    >
      <List>
        {menuItems
          .filter((item) => !item.isLogo)
          .map((item, index) => (
            <ListItem key={item.text} disablePadding>
              <ListItemButton
                onClick={(e) => {
                  e.preventDefault();
                  if (item.sectionId) {
                    scrollToSection(item.sectionId);
                  }
                }}
              >
                <ListItemIcon
                  color={stylesProvider.colors[stylesProvider.theme].highlight}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          ))}
      </List>
      <Divider />
      <DrawerLanguageMenu />
    </Box>
  );
  const iOS =
    typeof navigator !== "undefined" &&
    /iPad|iPhone|iPod/.test(navigator.userAgent);

  return (
    <div>
      <SwipeableDrawer
        disableBackdropTransition={!iOS}
        disableDiscovery={iOS}
        // anchor="top"
        anchor="left"
        open={open}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        slotProps={{
          paper: {
            sx: {
              backgroundColor:
                stylesProvider.colors[stylesProvider.theme].background,
              color: stylesProvider.colors[stylesProvider.theme].text,
            },
          },
        }}
      >
        {DrawerList}
      </SwipeableDrawer>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar
          // position="sticky"
          position={isMobile ? "fixed" : "static"}
          color={"transparent"}
          style={{
            backgroundColor: isMobile
              ? stylesProvider.colors[stylesProvider.theme].background
              : "transparent",
            boxShadow: "none",
            // borderBottomColor:
            //   stylesProvider.colors[stylesProvider.theme].border,
            // borderBottomWidth: "1px",
            // borderBottomStyle: "solid",
          }}
        >
          {isMobile ? (
            <Toolbar>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
                onClick={toggleDrawer(true)}
              >
                <MenuIcon />
              </IconButton>
              <div
                style={{
                  flexGrow: 1,
                  justifyContent: "flex-end",
                  display: "flex",
                  paddingTop: "8px",
                  paddingBottom: "4px",
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      stylesProvider.colors[stylesProvider.theme].text,
                    padding: "10px 16px",
                    borderRadius: "20%",
                  }}
                >
                  <Logo size={40} />
                </div>
              </div>
            </Toolbar>
          ) : (
            <Toolbar
              sx={{
                justifyContent: "space-between",
                paddingTop: "10px",
                // columnGap: "30px",
              }}
            >
              {/* <div>
                <NoTextLogo />
              </div> */}
              {menuItems.map((item, index) => (
                <div key={item.text} style={{ flexShrink: 1 }}>
                  {item.isLogo ? (
                    item.icon
                  ) : (
                    <Text
                      type={item.isLogo ? "h3" : "a"}
                      href="#"
                      onClick={
                        item.isLogo
                          ? undefined
                          : (e: any) => {
                              e.preventDefault();
                              if (item.sectionId) {
                                scrollToSection(item.sectionId);
                              }
                            }
                      }
                      style={{
                        textDecoration: "none",
                      }}
                    >
                      {item.text}
                    </Text>
                  )}
                </div>
              ))}
              <LanguageMenu />
              {/* <div style={{ display: "flex", alignItems: "center" }}>
                <LinkedIn
                  sx={{
                    color: stylesProvider.colors[stylesProvider.theme].link,
                    fontSize: "30px",
                  }}
                />
              </div> */}
            </Toolbar>
          )}
        </AppBar>
      </Box>
    </div>
  );
}

const DrawerLanguageMenu = () => {
  const { lang, supportedLanguages, setLocale } = useLanguageContext();
  const CountryItem = (item: {
    langCode: string;
    countryCode: string;
    name: string;
  }) => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
        onClick={() => setLocale(item.langCode as any)}
      >
        <ReactCountryFlag countryCode={item.countryCode} svg />
        <Text type="p" size="small">
          {item.name}
        </Text>
      </div>
    );
  };
  return (
    <div style={{ padding: "0 20px" }}>
      {supportedLanguages.map((lang) => CountryItem(lang))}
    </div>
  );
};

const LanguageMenu = () => {
  const { theme, colors } = useStyle();

  const { lang, supportedLanguages, setLocale } = useLanguageContext();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (langCode: string) => {
    setLocale(langCode as any);
    handleClose();
  };

  const CountryItem = (item: {
    langCode: string;
    countryCode: string;
    name: string;
  }) => {
    return (
      <MenuItem
        onClick={() => handleLanguageChange(item.langCode)}
        style={{
          display: "flex",
          justifyContent: "space-between",
          columnGap: "10px",
        }}
      >
        <ReactCountryFlag countryCode={item.countryCode} svg />
        <Text type="p" size="small">
          {item.name}
        </Text>
      </MenuItem>
    );
  };

  const currentLang = supportedLanguages.find(
    (l) => l.langCode === lang.locale,
  );

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <button
          onClick={handleClick}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          {currentLang && (
            <ReactCountryFlag countryCode={currentLang.countryCode} svg />
          )}
          <Text type="a" uppercase={true}>
            {currentLang?.name}
          </Text>
          <KeyboardArrowDown
            sx={{
              color: colors[theme].text,
            }}
          />
        </button>
      </div>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        slotProps={{
          paper: {
            sx: {
              backgroundColor: colors[theme].background,
              color: colors[theme].text,
              borderRadius: "0px",
            },
          },
        }}
      >
        {supportedLanguages.map((lang) => CountryItem(lang))}
      </Menu>
    </div>
  );
};
